import {
  Dropdown,
  Menu,
  Avatar,
} from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { userImplement } from '@/config/hooks/user';
import { ENV } from '@/infrastructure/env-config';
import { ConfigTabType } from '@/presentation/pages/setting/app-deliver-config/api';
import { stores } from '@/presentation/store';

export const AvatarMenu = () => {
  const history = useHistory();
  const { isSuperUser } = stores.ProductStore;

  const handleSelect = (key: string) => {
    switch (key) {
      case 'myApp':
        history.push('/workbench/apps');
        break;
      case 'profile':
        history.push('/user/profile');
        break;
      case 'coupons':
        history.push('/user/coupons');
        break;
      case 'approval':
        history.push('/product-approval');
        break;
      case 'configManage':
        history.push(`/config-manage?bar=${ConfigTabType.DEFAULT}`);
        break;
      case 'usageDetails':
        history.push('/usage-details');
        break;
      case 'resourceManage':
        history.push('/resource-manage');
        break;
      case 'expense':
        history.push('/expense');
        break;
      case 'approvalTrial':
        history.push('/trial-approval');
        break;
      default:
        userImplement.logout();
        break;
    }
  };

  const menu = () => (
    <Menu onClick={({ key }) => handleSelect(key)}>
      <Menu.Item key="myApp">
        我的产品
      </Menu.Item>
      <Menu.Item key="profile">
        个人信息
      </Menu.Item>
      {isSuperUser ? <Menu.Item key="configManage">
        配置管理
      </Menu.Item> : null}
      {(!ENV.isGlobal) && <Menu.Item key="expense">
        订单管理
      </Menu.Item>}
      {isSuperUser ? <Menu.Item key="approvalTrial">
        运营活动审批
      </Menu.Item> : null}
      <Menu.Item key="resourceManage">
        资源包
      </Menu.Item>
      {isSuperUser ? <Menu.Item key="usageDetails">
        用量明细
      </Menu.Item> : null}
      {isSuperUser ? <Menu.Item key="approval">
        产品审批
      </Menu.Item> : null}
      <Menu.Item key="logout">
        退出登录
      </Menu.Item>
    </Menu>
  );

  return <Dropdown overlay={menu} placement={'bottomRight'}>
    <Avatar style={{ marginBottom: '5px' }} size={28} src={userImplement.getAvatar()} />
  </Dropdown>;
};
